import * as Sentry from '@sentry/vue';
import * as API from '@/modules/admin/guests/_api';

// @ts-ignore
export const read = async ({commit, dispatch}) => {
  try {
    const all = await API.read();
    commit('setAll', all);
    return true;
  } catch (ex: any) {
    Sentry.captureException(ex);
    dispatch('common/snackbar/error', 'Fatal Error. Please try again later', {root: true});
    return false;
  }
};

// @ts-ignore
export const readOne = async ({commit, dispatch}, {id}) => {
  try {
    const one = await API.readOne(id);
    commit('setOne', one);
    return true;
  } catch (ex: any) {
    Sentry.captureException(ex);
    dispatch('common/snackbar/error', 'Fatal Error. Please try again later', {root: true});
    return false;
  }
};

// @ts-ignore
export const update = async ({commit, dispatch}, guest) => {
  try {
    await API.update(guest);
    return true;
  } catch (ex: any) {
    Sentry.captureException(ex);
    dispatch('common/snackbar/error', ex, {root: true});
    return false;
  }
};

// @ts-ignore
export const create = async ({commit, dispatch}, guest) => {
  try {
    return await API.create(guest);
  } catch (ex: any) {
    if (ex.response.status === 422) {
      dispatch('common/snackbar/error', 'Email Adresse ist bereits hinterlegt', {root: true});
    } else {
      dispatch('common/snackbar/error', ex, {root: true});
    }
    Sentry.captureException(ex);
    return false;
  }
};

// @ts-ignore
export const remove = async ({commit, dispatch}, {id}) => {
  try {
    await API.del(id);
    return true;
  } catch (ex: any) {
    Sentry.captureException(ex);
    dispatch('common/snackbar/error', 'Fatal Error. Please try again later', {root: true});
    return false;
  }
};

